<template>
    <div class="page active" ref="scroller ">
        <div class="top-header">
            <header class="header">
                <div class="left">
                    <span>
                        {{ title }}
                    </span>
                </div>
                <div class="right">
                    <div
                        v-if="episodes.length > 0"
                        class="btn video-course-btn"
                        @click="changeShowCourseList(true)"
                    >
                        <img
                            class="video-course-list-logo"
                            src="~@/assets/video-course-list-logo.png"
                            alt=""
                        />
                        <span>列表</span>
                    </div>
                    <div class="btn zhuanji-btn" v-if="id != 'NEWEST'">
                        <img
                            class="zhuanji-logo"
                            src="~@/assets/zhuanji-logo.png"
                            alt=""
                        />
                        <span @click="goBack()">课程</span>
                    </div>
                    <!-- <div class="btn yaoqing-btn">
                    <img
                        class="yaoqing-logo"
                        src="~@/assets/yaoqing-logo.png"
                        alt=""
                    />
                    <span>邀请</span>
                </div> -->
                </div>
            </header>
            <div class="videoBox" v-if="type == 'VIDEO'">
                <div class="prism-player" id="J_prismPlayer"></div>
            </div>
            <div class="audioBox" v-if="type == 'AUDIO'">
                <my-audio
                    ref="audio"
                    :audio="audio"
                    @trySeeEvent="trySeeEvent"
                ></my-audio>
            </div>
        </div>
        <div class="box" v-if="type != 'ARTICLE'">
            <div class="twb" v-if="!isDisabled">
                <div class="introBox">
                    <!-- <img class="tuwenban" src="~@/assets/tuwenban.png" alt="" /> -->
                    <div
                        class="intro article"
                        ref="article"
                        v-html="wordPic"
                        :class="{ active: isReadAll }"
                    ></div>
                </div>
            </div>
            <!-- <div
                class="readAll"
                @click="readAll($event)"
                v-html="readAllContent"
            ></div> -->

            <div class="commentBox" v-if="openComment">
                <add-comment :disabled="isDisabled"></add-comment>
                <comment-list
                    :data="commentList"
                    :avgScore="avgScore"
                    :isClick="!isDisabled"
                    @update="getCommentList()"
                ></comment-list>
            </div>
        </div>
        <div class="box" v-else>
            <div class="article" ref="article" v-html="wordPic"></div>
            <div class="commentBox articleComment" v-if="openComment">
                <add-comment :disabled="isDisabled"></add-comment>
                <comment-list
                    :data="commentList"
                    :avgScore="avgScore"
                    :isClick="!isDisabled"
                    @update="getCommentList()"
                ></comment-list>
            </div>
        </div>

        <van-popup class="course-list" v-model="show" position="bottom">
            <div class="top-header">
                <div class="title">课程列表</div>
                <img
                    class="circle-arrow-down"
                    src="~@/assets/circle-arrow-down.png"
                    alt=""
                    @click="changeShowCourseList(false)"
                />
            </div>
            <div class="list">
                <div class="item" v-for="item in episodes" :key="item.id">
                    <div class="top">
                        <div class="left">
                            <span>第{{ item.myIndex }}集</span>
                            <span>{{ item.title }}</span>
                        </div>
                        <div class="right" @click="playVideo(item)">
                            <template v-if="item.type !== 'ARTICLE'">
                                <img
                                    v-if="item.ifFree"
                                    class="player"
                                    src="~@/assets/free-player.png"
                                    alt=""
                                />
                                <img
                                    v-else-if="
                                        !item.ifFree &&
                                            (item.ifBuy || trySeeTime > 0)
                                    "
                                    class="player"
                                    src="~@/assets/player.png"
                                    alt=""
                                />
                                <span
                                    :class="{ free: item.ifFree }"
                                    v-if="item.ifFree"
                                >
                                    免费观看
                                </span>
                                <span
                                    v-if="!item.ifFree"
                                    :class="[
                                        trySeeTime > 0 || item.ifBuy
                                            ? 'active'
                                            : '',
                                    ]"
                                >
                                    {{
                                        item.ifBuy
                                            ? "观看"
                                            : trySeeTime
                                            ? "试看"
                                            : ""
                                    }}
                                </span>
                            </template>
                            <template v-else>
                                <img
                                    v-if="item.ifFree"
                                    class="player"
                                    src="~@/assets/article-free-logo.png"
                                    alt=""
                                />
                                <img
                                    v-else-if="!item.ifFree && item.ifBuy"
                                    class="player"
                                    src="~@/assets/article-logo.png"
                                    alt=""
                                />
                                <span
                                    :class="{ free: item.ifFree }"
                                    v-if="item.ifFree"
                                >
                                    免费阅读
                                </span>
                                <span
                                    v-if="!item.ifFree"
                                    :class="[item.ifBuy ? 'active' : '']"
                                >
                                    {{ item.ifBuy ? "阅读" : "" }}
                                </span>
                            </template>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="left">{{ item.pubTime }}</div>
                        <div class="right">
                            <template v-if="item.type != 'ARTICLE'">
                                <img
                                    class="courseTimeLogo"
                                    src="~@/assets/course-time.png"
                                    alt=""
                                />
                                <span class="courseTime">{{
                                    item.videoTime
                                }}</span>
                                <span class="line"></span>
                            </template>
                            <img
                                class="courseStudentLogo"
                                src="~@/assets/course-student.png"
                                alt=""
                            />
                            <span class="courseStudentNum">
                                {{ item.inUserNum }}人学过
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jm-notice">—— 没有更多数据了 ——</div>
        </van-popup>
    </div>
</template>

<script>
    import CommentList from "../../components/comment-list/comment-list.vue";
    import videoCourseService from "../../service/video-course.service";
    import commentService from "../../service/comment.service";
    import rx from "../../_rx";
    import { Toast } from "vant";
    import { initphotSwipe } from "../../common";
    import AddComment from "../../components/add-comment/add-comment";
    import MyAudio from "../../components/my-audio/my-audio.vue";
    import Cookies from "js-cookie";
    export default {
        name: "video-course",
        components: {
            "comment-list": CommentList,
            "add-comment": AddComment,
            "my-audio": MyAudio,
        },
        data() {
            return {
                courseType: "",
                courseId: "",
                id: "",
                show: false,
                title: "",
                videoLink: "",
                tryeLink: "",
                ifFree: false,
                ifBuy: false,
                episodes: [],
                commentList: [],
                myScore: 0,
                wordPic: "",
                avgScore: 0,
                isReadAll: false,
                videoEl: null,
                player: null,
                trySeeTime: 0,
                type: "ARTICLE",
                videoShot: "",
                openSell: false,
                readAllContent: "",
                openComment: false,
                commentArticleData: [],
                audio: null,
                progressMarkers: [],
                timer: null,
            };
        },
        computed: {
            isDisabled() {
                if (this.ifFree || this.ifBuy) {
                    return false;
                }
                return true;
            },
        },
        mounted() {
            this.id = this.$route.params.id;
            this.courseId = this.$route.query.courseId;
            this.courseType = this.$route.query.courseType;
            this.init();
            this.getCommentList();
            rx.on("reloadVideo", () => {
                this.loadVideo(false);
            });
        },
        watch: {
            $route() {
                this.id = this.$route.params.id;
                this.courseId = this.$route.query.courseId;
                this.init();
                this.getCommentList();
            },
        },

        methods: {
            trySeeEvent() {
                rx.emit("showFeedback", {
                    goodsId: this.courseId,
                    goodsCode: "STUDY",
                    episodeId: this.id,
                });
            },
            init() {
                videoCourseService
                    .getEpisodeDetail({ id: this.id, courseId: this.courseId })
                    .then((res) => {
                        this.title = res.data.title;
                        this.ifFree = res.data.ifFree;
                        this.videoLink = res.data.videoLink;
                        this.ifBuy = res.data.ifBuy;
                        this.episodes = res.data.episodes;
                        this.wordPic = res.data.wordPic;
                        this.avgScore = res.data.avgScore;
                        this.trySeeTime = res.data.trySeeTime;
                        this.type = res.data.type;
                        let isTryVideo = false;
                        this.videoShot = res.data.videoShot;
                        this.openSell = res.data.openSell;
                        initphotSwipe.call(this, ".article img");
                        this.loadVideo(isTryVideo);
                        this.openComment = res.data.openComment;
                        this.progressMarkers = res.data.progressMarkers || [];

                        this.audio = {
                            url: res.data.videoLink,
                            time: res.data.videoTime,
                            filename: res.data.videoName,
                            trySeeTime: (res.data.trySeeTime / 60).toFixed(2),
                            ifFree: res.data.ifFree,
                            ifBuy: res.data.ifBuy,
                        };

                        this.readAllContent = this.isReadAll
                            ? "收起"
                            : this.ifFree
                            ? "阅读全文"
                            : this.ifBuy
                            ? "阅读全文"
                            : this.openSell
                            ? `
                            <div class="left" @click="show()">购买单集</div>
                            <div class="right">购买全课程</div>
                            `
                            : "购买课程后，即可观看全文";

                        setTimeout(() => {
                            document.querySelector(".box").scrollTop = 0;
                            let commentId = this.$route.query.commentId;
                            if (commentId) {
                                document
                                    .getElementById(commentId)
                                    .scrollIntoView();
                            }

                            let auidoVm = this.$refs.audio;
                            if (auidoVm) {
                                this.$refs.audio.clear();
                            }
                        }, 25);
                    });
            },
            loadVideo(isTryVideo) {
                this.$nextTick().then(() => {
                    if (this.type == "VIDEO") {
                        let obj = {};
                        if (!this.ifFree) {
                            if (!this.ifBuy) {
                                isTryVideo = true;
                                obj["components"] = [
                                    {
                                        name: "PreviewVodComponent",
                                        type:
                                            window.AliPlayerComponent
                                                .PreviewVodComponent,
                                        args: [
                                            Math.round(this.trySeeTime),
                                            "",
                                            `<a  class="vip-join">购买课程</a> 观看完整视频`,
                                        ],
                                    },
                                ];
                            }
                        }

                        this.player = new window.Aliplayer(
                            Object.assign(
                                {},
                                {
                                    id: "J_prismPlayer",
                                    width: "100%",
                                    height: "4.8rem",
                                    language: "zh-cn",
                                    source: this.videoLink,
                                    vodRetry: 3,
                                    cover: this.videoShot,
                                    autoplay: true,
                                    useH5Prism: true,
                                    keyShortCuts: true,
                                    showBuffer: true,
                                    preload: true,
                                    // eslint-disable-next-line no-dupe-keys
                                    skinLayout: [
                                        { name: "bigPlayButton", align: "cc" },
                                        {
                                            name: "H5Loading",
                                            align: "cc",
                                        },
                                        {
                                            name: "errorDisplay",
                                            align: "tlabs",
                                            x: 0,
                                            y: 0,
                                        },
                                        { name: "infoDisplay" },
                                        {
                                            name: "tooltip",
                                            align: "blabs",
                                            x: 0,
                                            y: 56,
                                        },

                                        {
                                            name: "controlBar",
                                            align: "blabs",
                                            x: 0,
                                            y: 0,
                                            children: [
                                                {
                                                    name: "progress",
                                                    align: "blabs",
                                                    x: 0,
                                                    y: 44,
                                                },
                                                {
                                                    name: "playButton",
                                                    align: "tl",
                                                    x: 15,
                                                    y: 12,
                                                },
                                                {
                                                    name: "timeDisplay",
                                                    align: "tl",
                                                    x: 10,
                                                    y: 7,
                                                },

                                                {
                                                    name: "fullScreenButton",
                                                    align: "tr",
                                                    x: 5,
                                                    y: 12,
                                                },
                                                {
                                                    name: "volume",
                                                    align: "tr",
                                                    x: 5,
                                                    y: 10,
                                                },
                                                {
                                                    name: "setting",
                                                    align: "tr",
                                                    x: 5,
                                                    y: 12,
                                                },
                                            ],
                                        },
                                    ],
                                    progressMarkers: this.progressMarkers,
                                },
                                obj,
                            ),
                            (player) => {
                                if (isTryVideo) {
                                    var vipJoinBtn = document.querySelector(
                                        ".vip-join",
                                    );
                                    vipJoinBtn.addEventListener("click", () => {
                                        // this.$router.push({
                                        //     path: "/pay/STUDY",
                                        //     query: { id: this.courseId },
                                        // });
                                        this.$router.back();
                                    });

                                    player.on("ended", () => {
                                        rx.emit("showFeedback", {
                                            goodsId: this.courseId,
                                            goodsCode: "STUDY",
                                            episodeId: this.id,
                                        });
                                        setTimeout(() => {
                                            let previewVodComponent = player.getComponent(
                                                "PreviewVodComponent",
                                            );
                                            previewVodComponent &&
                                                previewVodComponent.closePreviewLayer();
                                            player.dispose();
                                        }, 0);
                                    });
                                } else {
                                    // this.deleteVideoProcessByExpireTime();
                                    // let videosProcess = this.readVideosProcess();
                                    let currentTime = Cookies.get(this.id) || 0;
                                    player.loadByUrl(
                                        this.videoLink,
                                        currentTime,
                                    );
                                    // if (currentTime) {
                                    //     player.seek(currentTime);
                                    // }

                                    const clearTimer = () => {
                                        if (this.timer) {
                                            clearInterval(this.timer);
                                        }
                                    };

                                    const saveVideProcess = () => {
                                        clearTimer();
                                        Cookies.set(
                                            this.id,
                                            Math.floor(player.getCurrentTime()),
                                            {
                                                expires: 7,
                                            },
                                        );
                                        this.timer = setInterval(() => {
                                            Cookies.set(
                                                this.id,
                                                Math.floor(
                                                    player.getCurrentTime(),
                                                ),
                                                {
                                                    expires: 7,
                                                },
                                            );
                                        }, 3000);
                                    };
                                    player.on("play", saveVideProcess);
                                    player.on("completeSeek", saveVideProcess);
                                    player.on("pause", clearTimer);
                                    player.on("error", clearTimer);
                                    player.on("ended", () => {
                                        clearTimer();
                                        // this.deleteVideoProcessById();
                                        Cookies.remove(this.id);
                                    });
                                }
                            },
                        );
                    }
                });
            },
            // deleteVideoProcessByExpireTime() {
            //     let videosProcessStr = localStorage.getItem("videoProcess");
            //     if (videosProcessStr) {
            //         let videosProcess = JSON.parse(videosProcessStr);
            //         for (let key in videosProcess) {
            //             let process = videosProcess[key];
            //             if (Date.now() > process.expireTime) {
            //                 delete videosProcess[key];
            //             }
            //         }
            //         localStorage.setItem(
            //             "videoProcess",
            //             JSON.stringify(Object.assign({}, videosProcess)),
            //         );
            //     }
            // },
            // deleteVideoProcessById() {
            //     let videosProcessStr = localStorage.getItem("videoProcess");
            //     if (videosProcessStr) {
            //         let videosProcess = JSON.parse(videosProcessStr);

            //         delete videosProcess[this.id];
            //         localStorage.setItem(
            //             "videoProcess",
            //             JSON.stringify(Object.assign({}, videosProcess)),
            //         );
            //     }
            // },
            // readVideosProcess() {
            //     let videosProcessStr = localStorage.getItem("videoProcess");
            //     if (videosProcessStr) {
            //         let videosProcess = JSON.parse(videosProcessStr);
            //         if (
            //             videosProcess &&
            //             Object.keys(videosProcess).length > 0
            //         ) {
            //             return videosProcess;
            //         }
            //         return null;
            //     }
            // },
            // saveVideosProcess(currentTime) {
            //     let videosProcess = this.readVideosProcess();
            //     localStorage.removeItem("videoProcess");
            //     localStorage.setItem(
            //         "videoProcess",
            //         JSON.stringify(
            //             Object.assign({}, videosProcess, {
            //                 [this.id]: {
            //                     currentTime: currentTime,
            //                     expireTime: Date.now() + 7 * 24 * 3600 * 1000,
            //                 },
            //             }),
            //         ),
            //     );
            // },
            changeShowCourseList(isShow) {
                this.show = isShow;
            },
            goBack() {
                this.$router.push({
                    path: `/course-detail/${this.courseId}/${this.courseType}`,
                });
            },

            getCommentList() {
                commentService
                    .getList({
                        classify: "STUDY_EPISODE",
                        clssifyforId: this.id,
                    })
                    .then((res) => {
                        this.commentList = res.data.list;
                        setTimeout(() => {
                            initphotSwipe.call(
                                this,
                                ".comment-list .reply img",
                            );
                        }, 200);
                    });
            },
            readAll(e) {
                let target = e.target;
                if (!this.ifFree) {
                    if (!this.ifBuy) {
                        if (this.openSell) {
                            if (target.getAttribute("class") == "left") {
                                this.$router.push({
                                    path: `/pay/STUDY_EPISODE`,
                                    query: { id: this.id },
                                });
                            } else if (
                                target.getAttribute("class") == "right"
                            ) {
                                this.$router.push({
                                    path: `/pay/STUDY`,
                                    query: { id: this.courseId },
                                });
                            }
                        } else {
                            this.$router.push({
                                path: "/pay/STUDY",
                                query: { id: this.courseId },
                            });
                        }
                    }
                }
                this.isReadAll = !this.isReadAll;
            },
            playVideo(obj) {
                if (obj.id != this.id) {
                    this.show = false;
                    this.$router
                        .push({
                            path: `/video-course/${obj.id}`,
                            query: {
                                courseId: this.courseId,
                                couseType: this.courseType,
                            },
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    if (this.player) {
                        this.player.dispose();
                    }
                } else {
                    Toast("正在观看");
                }
            },
        },
    };
</script>

<style lang="scss" scoped src="./video-course.scss"></style>
